<template>
    <DataTable :value="familia" responsiveLayout="scroll">
			<Column field="afiliadoID" header="ID"></Column>
			<Column field="familiar" header="Familiar"></Column>
			<Column field="cuil" header="CUIL"></Column>
			<Column field="nombre" header="Nombre"></Column>
			<Column field="estado" header="Estado"></Column>
			<Column field="getFechaNacimiento"  header="Fec. Nac."></Column>
			<Column field="edad" header="Edad"></Column>
		</DataTable>
</template>

<script>
    import {ref, onMounted, inject} from 'vue'
    import WService from '@/plugins/ws';
    import Menu from 'primevue/menu';
    import DataTable from 'primevue/datatable';
    import Column from 'primevue/column';
    

    export default {
        components: {
            Menu, DataTable, Column,  WService,
        },
    props: {
        idAfiliado: Number,
    },  
        setup(props){
            
            const wService = ref(new WService());
            const familia = ref([]);
            onMounted(() => {
                
                console.log(props.cuilTitular)
                wService.value.getMethod(`Afiliados/IosepSalud/GetGrupoFamiliar/${props.idAfiliado}`).then(info => {
                    console.log(info);
                    familia.value = info;

                }).catch(err => {
                    console.log(err.message);
                });
            })

            return {familia}
        }
    }


</script>